
export const getWheelSettingsTab = (state) => state.wheelSettings.selectedTab;